export default "__VITE_ASSET__aW18LkIj__"